export class ServiceFileModel{
    id:number;
    service_type: string;
    service_id:number;
    filename: string;
    file_type: string;
}